function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHexagon = function SvgIconHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 210 238"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M97 2.619a16 16 0 0 1 16 0l88.789 51.262a16 16 0 0 1 8 13.857v102.524a16 16 0 0 1-8 13.857L113 235.381a16 16 0 0 1-16 0L8.21 184.119a16 16 0 0 1-8-13.857V67.738a16 16 0 0 1 8-13.857L97 2.62Z"
  }));
};
export default SvgIconHexagon;